/**
 * configurator API
 * configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface FusionActionConf { 
    action?: FusionActionConf.ActionEnum;
    field?: string;
    typeField?: FusionActionConf.TypeFieldEnum;
}
export namespace FusionActionConf {
    export type ActionEnum = 'ADITION' | 'EQUALS';
    export const ActionEnum = {
        ADITION: 'ADITION' as ActionEnum,
        EQUALS: 'EQUALS' as ActionEnum
    };
    export type TypeFieldEnum = 'String255' | 'String25' | 'String3' | 'String100' | 'String10' | 'String50' | 'TEXT' | 'Int' | 'BigInt' | 'Decimal_5_2' | 'Decimal_8_2' | 'Decimal_11_2' | 'Boolean' | 'DateTime' | 'Date' | 'Time' | 'UUID';
    export const TypeFieldEnum = {
        String255: 'String255' as TypeFieldEnum,
        String25: 'String25' as TypeFieldEnum,
        String3: 'String3' as TypeFieldEnum,
        String100: 'String100' as TypeFieldEnum,
        String10: 'String10' as TypeFieldEnum,
        String50: 'String50' as TypeFieldEnum,
        TEXT: 'TEXT' as TypeFieldEnum,
        Int: 'Int' as TypeFieldEnum,
        BigInt: 'BigInt' as TypeFieldEnum,
        Decimal52: 'Decimal_5_2' as TypeFieldEnum,
        Decimal82: 'Decimal_8_2' as TypeFieldEnum,
        Decimal112: 'Decimal_11_2' as TypeFieldEnum,
        Boolean: 'Boolean' as TypeFieldEnum,
        DateTime: 'DateTime' as TypeFieldEnum,
        Date: 'Date' as TypeFieldEnum,
        Time: 'Time' as TypeFieldEnum,
        UUID: 'UUID' as TypeFieldEnum
    };
}
